<template>
  <div>
    <base-specification-config :number-of-parts="retend.numberOfParts"
                               :number-of-payments="retend.numberOfPayments"
                               :nb-of-prepayment-payments="retend.datePointContract"
                               :nb-of-payments-after-delivery="retend.datePointDelivery"
                               :nb-of-payments-after-acceptance="retend.datePointReceive"
                               :allow-options="retend.allowOptions"
                               :can-configure-parts="canConfigureParts"
                               :can-configure-payments="canConfigurePayments"
                               @refresh="onSpecificationRefreshClick">
    </base-specification-config>
  </div>
</template>

<script>
  import PermissionsMixins from '../mixins/permissions'
  import CommonMixins from '../mixins/common'
  import BaseSpecificationConfig from "../common/base-SpecificationConfig";

  export default {
    components: {
      BaseSpecificationConfig
    },

    props: {
      lot: {
        type: Object,
        required: true
      },

      retend: {
        type: Object,
        required: true
      }
    },

    mixins: [
      PermissionsMixins,
      CommonMixins
    ],

    computed: {
      canConfigureParts() {
        return this.canEditRetend;
      },

      canConfigurePayments() {
        return this.canEditRetend;
      }
    },

    methods: {
      onSpecificationRefreshClick(data) {
        Object.assign(this.retend, {
          numberOfParts: data.numberOfParts,
          numberOfPayments: data.numberOfPayments,
          datePointContract: data.nbOfPrepaymentPayments,
          datePointDelivery: data.nbOfPaymentsAfterDelivery,
          datePointReceive: data.nbOfPaymentsAfterAcceptance
        });
        this.retend.recalc();
        this.saveForm();
      }
    }
  }
</script>

<style scoped>

</style>
